import {Box, Flex, FormLabel, Input} from '@chakra-ui/react';
import React, {useState, useRef, useEffect} from 'react';
import {CustomSelect} from '../General/FormInputs';
import {get} from '../../service/ApiService';
import {Arranger} from '../../service/Urls';
import ErrorHelper from '../../service/ErrorHelper';

// Takes in register, errors, and an id for the form value when page is submitted.
export const ArrangerSelect = props => {
  const [toast, setToast] = useState('');
  const [arrangers, setArrangers] = useState([]);
  const arrangerInput = useRef(null);
  const [value, setValue] = useState('');

  useEffect(() => {
    if (arrangers[0]) {
      setValue(arrangers[0].id);
      if (props.setRHFValue) props.setRHFValue(props.id, arrangers[0].id);
    }
  }, [arrangers]);

  useEffect(() => {
    if (props.disabled) {
      arrangerInput.current.value = null;
      setArrangers([]);
    }
  }, [props.disabled]);

  const getArrangers = async () => {
    const data = arrangerInput.current.value;
    if (data === '') {
      return;
    } else if (data.match(/^[0-9]+$/) && data.length >= 4) {
      let url = Arranger.GET_BY_CODE + '?ArrangerCode=' + data;
      if (props.clientId) {
        url += '&ClientId=' + props.clientId;
      }

      const response = await get(url);
      setArrangers([response]);
    } else if (data.toLowerCase().match(/^[a-z]+$/)) {
      let url = Arranger.GET_BY_NAME + '?ArrangerName=' + data;
      if (props.clientId) {
        url += '&ClientId=' + props.clientId;
      }

      const response = await get(url);
      setArrangers(response.data);
    } else {
      setToast({response: {error: true}, errorMessage: 'Can not search by given code.  Please enter numbers or letters to search for arrangers'});
    }
  };

  return (
    <Flex mr="auto" alignContent="bottom">
      <Box mr="1">
        <FormLabel htmlFor="account-rep" mb="-0.5" ml="1" fontSize="sm">
          Select
        </FormLabel>
        <Input
          ref={arrangerInput}
          onBlur={getArrangers}
          placeholder="ID or Name"
          disabled={props.disabled ?? false}
          onKeyPress={e => {
            if (e.key === 'Enter') {
              getArrangers();
            }
          }}
        />
      </Box>

      <Box w="100%">
        <CustomSelect
          id={props.id}
          register={props.register}
          errors={props.errors}
          value={value}
          onChange={e => setValue(e.target.value)}
          name="Select Arranger"
          disabled={props.disabled ?? false}
          required={props.required ? props.required : false}
        >
          {arrangers == []
            ? []
            : arrangers.map(arranger => {
                return (
                  <option key={arranger.id} value={arranger.id}>
                    {arranger.arName + ' - ' + arranger.arId}
                  </option>
                );
              })}
        </CustomSelect>
        <ErrorHelper toastResponse={toast} />
      </Box>
    </Flex>
  );
};
